import { useEffect } from 'react';

import { fetchSearchPageResults } from 'modules/search/zustand-stores/searchStore';

import { SearchContextInput } from './useSearchContextHeaderInput';

type Args = {
  searchContextInput: SearchContextInput | undefined;
  isSearching: boolean | undefined;
};

export function useSearchContextHeaderFetchPage({
  searchContextInput,
  isSearching,
}: Args) {
  useEffect(() => {
    if (!searchContextInput || isSearching) return;

    const { currentResultIndex, pageIndex, resultsByPage } = searchContextInput;
    const results = resultsByPage[pageIndex];

    // pre-fetch the previous page of results if we're on one of the first two results in the page
    if (
      currentResultIndex <= 1 &&
      pageIndex > 0 &&
      !resultsByPage[pageIndex - 1]
    ) {
      fetchSearchPageResults(pageIndex - 1);
    }

    // pre-fetch the next page of results if we're on one of the last two results in the page
    if (
      currentResultIndex >= (results.hitsPerPage || 0) - 2 &&
      pageIndex < results.nbPages - 1 &&
      !resultsByPage[pageIndex + 1]
    ) {
      fetchSearchPageResults(pageIndex + 1);
    }
  }, [isSearching, searchContextInput]);
}
